module.exports = __webpack_public_path__ + "static/img/SourceSansPro-Bold.833edcf.svg";